function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9546 5.19921L20.0013 16.4201L7.04527 5.19905C6.52938 4.75226 5.74302 4.80136 5.2887 5.30818C4.83454 5.81516 4.88399 6.58819 5.39987 7.03497L19.1788 18.9687C19.4139 19.1723 19.7078 19.2741 20.0015 19.2741C20.2952 19.2741 20.5892 19.1723 20.8244 18.9686L34.6005 7.03481C35.116 6.58819 35.1656 5.81499 34.7113 5.30802C34.2566 4.80153 33.4704 4.75259 32.9546 5.19921Z",
  fill: "#B01421"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2665 0H3.73349C1.67493 0 0 1.64638 0 3.67022V23.0819C0 25.1057 1.67493 26.7521 3.73349 26.7521H36.2665C38.3251 26.7521 40 25.1057 40 23.0819V3.67022C40 1.64654 38.3251 0 36.2665 0ZM37.511 23.0819C37.511 23.7564 36.9528 24.3053 36.2665 24.3053H3.73349C3.0472 24.3053 2.489 23.7564 2.489 23.0819V3.67022C2.489 2.99571 3.0472 2.44681 3.73349 2.44681H36.2665C36.9528 2.44681 37.511 2.99571 37.511 3.67022V23.0819Z",
  fill: "#2D2D2D"
});

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e2a9305c.svg";
export { ForwardRef as ReactComponent };